<template>
	<div class="col" :style="colSize">
		<slot></slot>
	</div>
</template>

<script>

	export default {
		props: {
			size: {
				default: 1
			}
		},
		computed: {
			colSize() {
				return `flex: ${+this.size}`;
			}
		}
	}
	
</script>

<style lang="scss" scoped>
	.col {
		flex: 1;
	}
</style>